import {
    svgTransformationDecode,
    svgTransformationEncode,
} from 'touchcontroller';

export function getBoundingRectWithoutRotation(element: Element) {
    //todo better without modification of element
    const tranformOriginalString = element.getAttribute('transform');
    const transform = svgTransformationDecode(
        tranformOriginalString || undefined,
    );
    transform.rotate = 0;
    element.setAttribute('transform', svgTransformationEncode(transform));
    const boundingRect = element.getBoundingClientRect();
    element.setAttribute('transform', tranformOriginalString || '');
    return boundingRect;
}
